"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const VerticalFocusDiv = styled_components_1.default.div `
  position: absolute;
  left: 0;

  width: 3px;
  height: ${(props) => props.height};
`;
const VerticalFocus = ({ height }) => {
    return (0, jsx_runtime_1.jsx)(VerticalFocusDiv, { className: "Vertical__Focus", height: height });
};
exports.default = react_1.default.memo(VerticalFocus);
